/* eslint-disable */
import './Products.css'
import 'instantsearch.css/themes/reset.css'
import React from 'react'
import axios from 'axios'
import { connect } from 'react-redux'
import { Grid, Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap'
import Card from 'components/Card/Card.jsx'
import Button from 'elements/CustomButton/CustomButton.jsx'
import '../../css/table.css'
import ReactTable from 'react-table'
import { orderBy, isEmpty, map } from 'lodash'
import { db, storage } from '../../services/firebase'
import SweetAlert from 'react-bootstrap-sweetalert'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import SweetSpinner from 'components/SweetSpinner/SweetSpinner.jsx'
import { InstantSearch, Hits, SearchBox, Highlight, Pagination } from 'react-instantsearch/dom'
import algoliaLogo from '../../assets/img/search-by-algolia.png'
import {
    setModel, setLine, setDescription, setCoverImage, addGalleryImage, addVariant, addVariantItem, cloneBeforeUpdate, setCoverImageName, setActive
} from '../../ducks/Product'


class Products extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            alert: null,
            products: [],
            loading: true
        }

        this.user = props.user
        this.resetForm = props.resetForm
        this.submitForm = props.submitForm
        this.notify = props.notify
    }

    render() {
        const { products, loading } = this.state

        const Search = () => {
            return (
                <div className='products__search'>
                    <SearchBox translations={{ placeholder: 'Digite aqui sua busca' }} />
                    <Row className='products__hits'>
                        <Hits hitComponent={Product} />
                    </Row>
                </div>
            )
        }

        const Product = ({ hit }) => {
            return (
                <Col md={6} sm={12}>
                    <div className='products__hit'>
                        <div className='hit__cover_frame'>
                            <img src={hit.coverImageURL} className='hit__cover' alt='cover' />
                        </div>
                        <div className='hit__content'>
                            <span className='hit__line'><span className='hit__line_label'>Linha</span> {hit.productLineName}</span>
                            <span className='hit__model'>{hit.model}</span>

                            <div className='hit__actions'>
                                <FontAwesomeIcon
                                    className='hit__action'
                                    icon='edit'
                                    onClick={() => this._populateRedux(hit.objectID)}
                                />

                                {/* <FontAwesomeIcon
                                    className='hit__action'
                                    icon='trash'
                                    onClick={() => this.removeProductAlert(hit.objectID)}
                                /> */}
                            </div>
                        </div>
                    </div>
                </Col>
            )
        }

        return (
            <div className='main-content'>
                {this.state.alert}
                <Card content={
                    <Grid fluid>
                        <Row>
                            <Col md={12}>
                                <InstantSearch
                                    appId="3HRDST3PYO"
                                    apiKey="7bfda90deb04fbad9b2fd5c232ff095c"
                                    indexName="products"
                                >
                                    <Search />
                                    <Pagination showLast />
                                    <Button
                                        bsStyle='default'
                                        wd
                                        className='products__add-new'
                                        onClick={() => this.props.history.push('/product/new')}
                                    >
                                        Adicionar Produto
                                    </Button>
                                </InstantSearch>
                                <Col md={12} className='algolia_logo_frame'>
                                    <a href='https://www.algolia.com/' target='blank'>
                                        <img src={algoliaLogo} className='algolia_logo' alt='cover' />
                                    </a>
                                </Col>
                            </Col>
                        </Row>
                    </Grid>
                } />
            </div>
        )
    }

    _populateRedux = id => {
        this.waitAlert('Preparando dados', true)

        db.collection('products').doc(id).get()
            .then(productSnap => {
                this.props.setModel(productSnap.data().model)
                this.props.setLine(productSnap.data().productLine)
                this.props.setDescription(productSnap.data().description)
                this.props.setActive(productSnap.data().active)

                if (productSnap.data().coverImageURL) {
                    let img = new Image()
                    img.src = productSnap.data().coverImageURL
                    this.props.setCoverImage(img)
                    this.props.setCoverImageName(productSnap.data().coverImageName)
                }

                if (productSnap.data().variants) {
                    map(productSnap.data().variants, variant => {
                        this.props.addVariant({
                            id: variant.id,
                            name: variant.name,
                            description: variant.description
                        })

                        if (variant.items && !isEmpty(variant.items)) {
                            map(variant.items, item => {
                                let newItem = {
                                    id: item.id,
                                    name: item.name,
                                    description: item.description,
                                    accessories: [],
                                    composition: [],
                                    fabricLines: []
                                }

                                if (!isEmpty(item.accessories)) {
                                    map(item.accessories, accessory => newItem.accessories.push({ ...accessory }))
                                }

                                if (!isEmpty(item.composition)) {
                                    map(item.composition, comp => newItem.composition.push({ ...comp }))
                                }

                                if (!isEmpty(item.fabricLines)) {
                                    map(item.fabricLines, line => newItem.fabricLines.push({ ...line }))
                                }

                                this.props.addVariantItem({ variantID: variant.id, newItem })
                            })
                        }
                    })
                }

                db.collection('products').doc(id).collection('gallery').get()
                    .then(gallerySnap => {
                        if (!gallerySnap.empty) {
                            gallerySnap.forEach(galleryImage => {
                                let image = new Image()
                                image.src = galleryImage.data().downloadURL
                                this.props.addGalleryImage({
                                    image,
                                    id: galleryImage.id,
                                    imageName: galleryImage.data().name
                                })
                            })

                            this.props.cloneBeforeUpdate()
                            this.hideAlert()
                            this.props.history.push(`/product/${id}`)
                        } else {
                            this.props.cloneBeforeUpdate()
                            this.hideAlert()
                            this.props.history.push(`/product/${id}`)
                        }

                    })
                    .catch(e => {
                        console.log(e)
                        this.hideAlert()
                        this.props.notify('Erro ao buscar imagens.', 'error')
                    })

            })
            .catch(e => {
                console.log(e)
                this.hideAlert()
                this.props.notify('Erro ao buscar produto.', 'error')
            })
    }

    // _removeProduct = id => {
    //     this.waitAlert('Removendo produto', false)

    //     const GalleryStack = []
    //     const StorageStack = []
    //     const imagesToRemove = []

    //     db.collection('products').doc(id).collection('gallery').get()
    //         .then(gallery => {
    //             console.log('Galeria coletada, analisando...')
    //             if (!gallery.empty) {
    //                 console.log('Removendo galeria...')
    //                 gallery.forEach(image => {
    //                     GalleryStack.push(
    //                         storage.ref().child(`products/${image.data().name}`).getDownloadURL()
    //                             .then(() => imagesToRemove.push(image.data().name)),

    //                         db.collection('products').doc(id).collection('gallery').doc(image.id).delete()
    //                     )
    //                 })

    //                 Promise.all(GalleryStack)
    //                     .then(() => {
    //                         console.log('Galeria removida. Removendo do storage...')
    //                         GalleryStack.map(g => StorageStack.push(storage.ref().child(`products/${g}`).delete()))

    //                         Promise.all(StorageStack)
    //                             .then(() => {
    //                                 console.log('Storage atualizado. Removendo produto...')
    //                                 axios.post('https://us-central1-enele-e47f5.cloudfunctions.net/syncAlgoliaDelete_HTTPS', { id })
    //                                     .then(() => {
    //                                         this.hideAlert()
    //                                         this.props.notify('Produto removido.', 'success')
    //                                     })
    //                                     .catch(e => {
    //                                         this.hideAlert()
    //                                         this.props.notify('Erro ao remover produto.', 'error')
    //                                     })
    //                             })
    //                             .catch(e => {
    //                                 this.hideAlert()
    //                                 this.props.notify('Erro ao remover produto.', 'error')
    //                             })
    //                     })
    //                     .catch(e => {
    //                         this.hideAlert()
    //                         this.props.notify('Erro ao remover produto.', 'error')
    //                     })

    //             }

    //             if (gallery.empty) {
    //                 console.log('Sem galeria pra remover. Removendo produto...')
    //                 db.collection('products').doc(id).delete()
    //                     .then(() => {
    //                         axios.post('https://us-central1-enele-e47f5.cloudfunctions.net/syncAlgoliaDelete_HTTPS', { id })
    //                             .then(res => {
    //                                 console.log('Produto removido!', res)
    //                                 this.hideAlert()
    //                                 this.props.notify('Produto removido.', 'success')
    //                             })
    //                             .catch(e => {
    //                                 console.log(e)
    //                                 this.hideAlert()
    //                                 this.props.notify('Erro ao remover produto.', 'error')
    //                             })
    //                     })
    //                     .catch(e => {
    //                         console.log(e)
    //                         this.hideAlert()
    //                         this.props.notify('Erro ao remover produto.', 'error')
    //                     })
    //             }
    //         })
    //         .catch(e => {
    //             console.log(e)
    //             this.hideAlert()
    //             this.props.notify('Erro ao remover produto.', 'error')
    //         })
    // }

    //SweetAlerts
    hideAlert = () => this.setState({ alert: null })

    waitAlert = (title, showSpinner) => {
        this.setState({
            alert: (
                <SweetAlert
                    style={{ display: 'block' }}
                    title={title}
                    onConfirm={() => null}
                    showConfirm={false}
                >
                    {showSpinner ? (<SweetSpinner />) : null}
                </SweetAlert>
            )
        })
    }

    removeProductAlert = productID => {
        this.setState({
            alert: (
                <SweetAlert
                    warning
                    style={{ display: "block" }}
                    title="Tem certeza?"
                    onConfirm={() => this._removeProduct(productID)}
                    onCancel={() => this.hideAlert()}
                    confirmBtnBsStyle="default"
                    cancelBtnBsStyle="warning"
                    confirmBtnText="Continuar"
                    cancelBtnText="Cancelar"
                    showCancel
                />
            )
        })
    }
}

const mapStateToProps = state => ({ product: state.product.product })

export default connect(mapStateToProps, {
    setModel, setLine, setDescription, setCoverImage, addGalleryImage, addVariant, addVariantItem, cloneBeforeUpdate, setCoverImageName, setActive
})(Products)



// WEBPACK FOOTER //
// ./src/views/Products/Products.jsx